import { useEffect, useState } from "react";
import { aboneaza, inchide, type Toast } from "../toasts";

// Stiva de mesaje, jos-dreapta. Se închid singure; se pot închide și cu mâna,
// fiindcă un mesaj de eroare peste care nu poți trece e el însuși o supărare.
export default function Toasts() {
  const [toasturi, setToasturi] = useState<Toast[]>([]);
  useEffect(() => aboneaza(setToasturi), []);

  if (!toasturi.length) return null;
  return (
    <div className="toasts" role="status" aria-live="polite">
      {toasturi.map((t) => (
        <div key={t.id} className={`toast ${t.fel}`}>
          <span>{t.fel === "lucru" && <span className="pulsa" />}{t.mesaj}</span>
          <button className="btng" onClick={() => inchide(t.id)}>✕</button>
        </div>
      ))}
    </div>
  );
}
